import {ProjectGroupResponseItem, ProjectGroupResponseList} from '@/types/service-response'

export class ProjectGroup {
  public constructor (
    readonly id: number,
    readonly name: string,
    readonly text: string,
    readonly code: string
  ) {}

  static createFromResponse (responseData: ProjectGroupResponseList): Array<ProjectGroup> {
    let result: Array<ProjectGroup> = []
    if (responseData) {
      result = responseData.map((item: ProjectGroupResponseItem ) => {
        return new ProjectGroup(
          item.ID,
          item.Bezeichnung,
          `${item.Bezeichnung} (${item.Code})`,
          item.Code
        )
      })
    }
    return result
  }
}
